<app-table-chart
  [title]="title"
  [tooltip]="tooltip"
  [rows]="rows"
  [rowTemplate]="row"
  [headersTemplate]="headers"
  [headerExtraContent]="headerExtraContent"
>
</app-table-chart>

<ng-template #headers>
  <th class="name-header">Name</th>
  <th class="violations-header">Violations</th>
</ng-template>

<ng-template #row let-row>
  <td [ngClass]="{ linkable: linkable }" (click)="onRowNameClicked(row.id)">
    {{ row.name | beautifyDisplayString }}
  </td>
  <td class="violation-columns">
    <app-violation-count
      (click)="onSeverityClicked('high', row.id)"
      [value]="row.high"
      [color]="'red'"
      [linkable]="linkable"
    >
    </app-violation-count>
    <app-violation-count
      (click)="onSeverityClicked('medium', row.id)"
      [value]="row.medium"
      [color]="'orange'"
      [linkable]="linkable"
    >
    </app-violation-count>
    <app-violation-count
      (click)="onSeverityClicked('low', row.id)"
      [value]="row.low"
      [color]="'yellow'"
      [linkable]="linkable"
    >
    </app-violation-count>
  </td>
</ng-template>
